module.exports = {
  personalizeTags: ["Personalisierbar"],
  sizeOptions: ["Größe"],
  colorOptions: ["Farbe"],
  colorMap: {
    Black: ["#00ff00", "#ff0000", "#ffff00"],
    Gray: "#c2c2c2",
    Green: ["#00ff00", "#ff0000", "#ffff00"],
    Purple: "#a020f0",
    Red: "#ff0000",
    White: "#ffffff",
    Yellow: "#ffff00",
  },
  fontMap: {
    pacifico: "Pacifico",
    merriweather: "Merriweather",
    quicksand: "Quicksand",
    sourcesanspro: "SourceSansPro",
  },
};
